/*
function updateProductPrice() {
    //featured product only

    let current_qty = $(".qty-pack-select.active").attr("ref");
    $(".main-product .quantity__input").val(current_qty);

    let lspdata = $("#loop-selling-plan-fieldset").attr("data-product")
    if(!lspdata){ return; }

  
    var loop_object = JSON.parse($("#loop-selling-plan-fieldset").attr("data-product"));
    var selected_variant = $("#loop-selling-plan-fieldset").attr("data-selected-variant-id");
    let variant_object = "";
    for (var key in loop_object['variants']) {
      let variant = loop_object['variants'][key];
      if(variant["id"]==selected_variant){
        variant_object = variant;
      }
    }


     var selected_selling_plan = $("#loop-selling-plan-fieldset").attr("data-selling-plan-id");
     let selling_plan_object = variant_object['selling_plan_allocations'][0];
     for (var key in variant_object['selling_plan_allocations']) {
        let sp = variant_object['selling_plan_allocations'][key];
        if(sp["selling_plan_id"]==selected_selling_plan){
          selling_plan_object = sp;
        }
    }

    
  
    let variant =  $(".main-product").attr("ref2");
    var selling_plan = $("#loop-selling-plan-fieldset").attr("data-selling-plan-group-name");
    let price = selling_plan_object['price'];
    let loop_price = selling_plan_object['price'];

    
    if(variant=='3-pack'){
        price = price-(price*0.22);
        loop_price = loop_price - (loop_price*0.22)
    }
    
    
    if(selling_plan=='loop-one-time-purchase') {
      price = selling_plan_object['compare_at_price'];
      if(variant=='3-pack'){
        price = price-(price*0.22);
      }
    } 
  
    price = (current_qty*price/100).toFixed(2);
    $(".main-product").attr("price", price);
  
    loop_price = (current_qty*loop_price/100).toFixed(2);
    loop_price = "$"+loop_price;
    
    price = "$"+price;
    $(".price-item--sale").html(price);
    
    let original_price = selling_plan_object['compare_at_price'];
    original_price = (current_qty*original_price/100).toFixed(2);
    let loop_original_price = "$"+original_price;
    original_price = "$"+original_price;
    $(".main-product .price__regular .price-item--regular").html(original_price);
  
    $(".main-product .loop-one-time-purchase-option-price-amount").html(loop_original_price);
    $(".main-product .loop-subscription-group-price-amount").html(loop_price);
    if(variant=='3-pack') {
      loop_original_price =  (current_qty * (selling_plan_object['compare_at_price']/100) * 0.78).toFixed(2);
      $(".main-product .loop-one-time-purchase-option-price-amount").html("$"+loop_original_price);
    }
    
    if(original_price!=price) {
      $(".main-product .price__container").addClass("sale_price");
    }else {
      $(".main-product .price__container").removeClass("sale_price");
    }
  
  
    $(".main-product .loop--price--change").show();
    
    updateLoads();
}

function selectLoopSubscription(){
   var loop_object = JSON.parse($("#loop-selling-plan-fieldset").attr("data-product"));
   var selected_variant = $("#loop-selling-plan-fieldset").attr("data-selected-variant-id");
   $(".featured-product #loop-product-variant-"+selected_variant+" .loop-subscription-group-radio" ).trigger("click");
}

function updateLoads() {
  let qty = 50;
  let scent =  $(".main-product").attr("ref"); 
  let variant =  $(".main-product").attr("ref2");
  let price =  $(".main-product").attr("price");
  if(variant == '1-pack') { qty = 50;}
  if(variant == '2-pack') { qty = 100;}
  if(variant == '3-pack') { qty = 150;}

  
  if(scent=='oasis-bundle') {
    qty=qty*2;
  }
  
  
  let perloadprice = ((price/qty)*100).toFixed(0);

  $(".main-product .loads_qty").html(qty+" Loads");
  $(".main-product .loads_price").html(perloadprice+"¢ per load");
  
}
*/

function updateCart() {
  
}

/*
function updateCart() {
  $(".cart-drawer .cart-item").each(function() {
      let option_color = $(this).find(".product_color").html();
      let title = option_color.replace("-", " ");
      $(this).find(".cart-item__name").html(title);
      
      let variant = $(this).find(".product_pack").html();
      let info =  $(this).find(".product-option-info");
      let info_text = "50 Loads (1 Pack)";
      let base_price = 29.99;
      let load = 50;
      let pack = 1;
      let qty =  $(this).find(".quantity__input").val();
      
      
      if(variant == '1-pack') { 
          load = 50;
          pack = 1;
          base_price = 29.99;
      }
      if(variant == '2-pack') { 
        load = 100;
        pack = 2;
        base_price = 59.98;
      }
      if(variant == '3-pack') { 
        load = 150;
        pack = 3;
        base_price = 89.97;
      }

     if(option_color=='oasis-bundle') {
       load = load*2;
     }

      let total_loads = load*qty;
      let total_packs = pack*qty;
      info_text = total_loads+" Loads ("+total_packs+" Pack)"; 
    
      $(this).find(".product-option-info").addClass("color_"+option_color);
      $(this).find(".product-option-info").html(info_text);

      //add discount price
      let current_price = $(this).find(".display_price").html().trim().replace('$', '');
      current_price = +current_price;
      let original_price = (qty*base_price).toFixed(2);
      //console.log(original_price, current_price);
      if(original_price!=current_price && option_color!='oasis-bundle'){
        //$(this).find(".price").html('<small class="original_price_bdiscount">$'+original_price+'</small> '+$(this).find(".price").html());
        $(this).find(".cart-item__old-price").html('$'+original_price);
      }

      //free shipping bar
      let fsb_price = $(".free_shipping_bar").attr('ref');
      fsb_price = +fsb_price;
      let total_price = $(".totals__total-value").html().trim().replace('$', '');
      total_price = total_price.replace(' USD', '');
      total_price = +total_price;
      let rem_amount  = fsb_price - total_price;
      let fsb_text = 'YOUR ORDER HAS FREE SHIPPING!';
      if(rem_amount>0) {
        fsb_text = 'you are $'+rem_amount.toFixed(2)+' from free shipping!';
      }
      
      let fsb_progress = (total_price/fsb_price)*100;
      let fsb_content = '<div class="progress-text">'+fsb_text+'</div><div class="progress"><div class="progress-bar" role="progressbar" style="width: '+fsb_progress+'%" aria-valuenow="'+fsb_progress+'" aria-valuemin="0" aria-valuemax="100"></div></div>';
      $(".free_shipping_bar").html(fsb_content);
  });
}

updateCart();
*/


$(".tab-pill").click(function(){
  const ref = $(this).attr("ref");
  $(".tab-pill").removeClass("active");
  $('[ref="'+ref+'"]').addClass("active");

  $(".tab-pane").removeClass("active");
  $("."+ref).addClass("active");
});


/*
const vari_class =  $(".main-product").attr("ref");
$("body").addClass(vari_class);
$(".oasis-pack-title").hide();

$(".color-swatch").click(function(){
  $("body").removeClass("italian-riviera african-sandalwood french-cognac oasis-bundle");
  const ref = $(this).attr("ref");
  $(".main-product").attr("ref", ref);
  $("body").addClass(ref);

  // Show/hide oasis-pack-title based on the active variant
  if (ref === "oasis-bundle") {
    $(".oasis-pack-title").show();
  } else {
    $(".oasis-pack-title").hide();
  }

  setTimeout(selectLoopSubscription, 10);
});


$(".vs-Pack label").click(function(){
  const ref2 = $(this).find(".vref").html().trim();
  $(".main-product").attr("ref2", ref2);
  updateLoads();
});
*/

$(".vs-gallery").click(function(){
  $("video")[0].pause();
})

/*
$(".loop-subscription-group-radio").click(function () {
  //console.log("loop-subscription-group-radio")
  setTimeout(updateProductPrice, 1);
})

$(".loop-one-time-purchase-option-radio").click(function () {
  //console.log("loop-subscription-group-radio");
  setTimeout(updateProductPrice, 1);
})


$(".loop-selling-plan-selector").change(function () {
  setTimeout(updateProductPrice, 1);
})



$(".vs-Pack").click(function () {
  setTimeout(updateProductPrice);
});

$(".vs-Color").click(function () {
  //update qty
  const ref =  $(".main-product").attr("ref");
  if(ref=='oasis-bundle') {
      $(".qty-pack").hide();
      $(".qty-pack-select").removeClass("active");
      $(".qty-pack-1").addClass("active");
      let qty = "1";
      $(".main-product").attr("ref2", qty+"-pack");
      $(".quantity__input").val(qty);
  } else {
      $(".qty-pack").hide();
      $(".qty-pack-select").removeClass("active");
      $(".qty-pack-2").addClass("active");
      let qty = "2";
      $(".main-product").attr("ref2", qty+"-pack");
      $(".quantity__input").val(qty);
      $(".qty-pack").show();
  }
  updateProductPrice();
  setTimeout(updateProductPrice, 1000);
});


$(".qty-pack-select").click(function () {
    $(".qty-pack-select").removeClass("active");
    $(this).addClass("active");
    let qty = $(this).attr("ref");
    $(".main-product").attr("ref2", qty+"-pack");
    $(".quantity__input").val(qty);
    updateProductPrice();
});
*/

/*
$( document ).ready(function() {

    //default qty 2 unles oasis-bundle
    const ref =  $(".main-product").attr("ref");
    if(ref=='oasis-bundle') {
      $(".qty-pack-select").removeClass("active");
      $(".qty-pack-1").addClass("active");
      let qty = "1";
      $(".main-product").attr("ref2", qty+"-pack");
      $(".main-product .quantity__input").val(qty);
    } else {
      $(".qty-pack-select").removeClass("active");
      $(".qty-pack-2").addClass("active");
      let qty = "2";
      $(".main-product").attr("ref2", qty+"-pack");
      $(".main-product .quantity__input").val(qty);
    }
    updateProductPrice();
});


$(".quantity__input").click(function () {
   updateProductPrice();
});
*/

for(var i = 1; i < 5; i++) {
  $(".marquee_content img").clone().prependTo( ".marquee_content" );
  $(".marquee_content span").clone().prependTo( ".marquee_content" );
}

/*
 $(".pg_scents li").click(function() {
  let scent = $(this).attr("ref");
  $(".vs-Color label[ref='"+scent+"']").trigger("click");
 });
*/

//page igredint 
/*
$(".ig-varient").click(function() {
  let scent = $(this).attr("ref");
  $(".pi-head li label").removeClass("active");
  $(this).addClass("active");
  $(".page-ingredients").removeClass("show-italian-riviera show-african-sandalwood show-french-cognac");
  $(".page-ingredients").addClass("show-"+scent)
});
*/

$(".unmatched_scents .multicolumn-card").click(function() {
     let link = $(this).find(".link").attr("href");
     window.location.href = link;
});


$(".footer-text a").click(function(e) {
  /*
  e.preventDefault();
  $(".footer-text").hide();
  $(".footer-form").show();
  $(".footer-form input").focus();
  */
  
});

$(document).on("submit", "#add-to-cart-form", function(event){
  event.preventDefault(); // prevent default form submission
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $(this).serialize(),
    dataType: 'json',
    success: function() {
       fetch(`${routes.cart_add_url}`)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
    },
    error: function() {
      // Do something on error (e.g. show an error message)
    }
  });
});

